import { style } from '@vtex/admin-ui-core'

export const centerStyle = style({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
})
